import { render, staticRenderFns } from "./point-item.vue?vue&type=template&id=11a00fa6&scoped=true"
import script from "./point-item.vue?vue&type=script&lang=js"
export * from "./point-item.vue?vue&type=script&lang=js"
import style0 from "./point-item.vue?vue&type=style&index=0&id=11a00fa6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a00fa6",
  null
  
)

export default component.exports